export enum WishListDropdownConstants {
  SHARE = 'share_list',
  EDIT_NAME = 'edit_list_name',
  DOWNLOAD = 'download',
  DELETE = 'delete',
  CSV = 'download_csv',
  PDF = 'download_pdf',
  XLSX = 'download_xlsx',
}